import Vue from 'vue';
import IdleVue from 'idle-vue'
import _ from 'lodash';
import AppComponent from './components/AppComponent.vue';

// #region sobrecarga clases
// Funciones para String
String.prototype.toIsoDate = function() {
  let d = this.split(' ');
  let c = d[0].split('-');
  return `${c[2]}-${c[1]}-${c[0]} ${d[1]}`;
}
String.prototype.toDate = function() {
  let d = this.split(' ');
  let c = d[0].split('-');
  c[1] = ['dic','ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'][c[1]];
  return c.join(' ');
}
String.prototype.toTime = function() {
  let d = this.split(' ');
  let c = d[1].split(':');
  return ('0' + c[0] + ':' + c[1]).slice(-5);
}
String.prototype.zeroFill = function(padlen=2, padchar=0) {
  var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
  var pad = new Array(1 + padlen).join(pad_char);
  return (pad + this).slice(-pad.length);
}
String.prototype.strToEuro = function() {
  let c = parseFloat(this.toString());
  if(c%1 == 0) return `${c} €`;
  return c.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}

// Funciones para fechas
Date.prototype.toIsoStr = function() {
  var y = this.getFullYear();
  var m = (this.getMonth()+1).toString().zeroFill();
  var d = this.getDate().toString().zeroFill();
  var h = this.getHours().toString().zeroFill();
  var n = this.getMinutes().toString().zeroFill();
  return `${y}-${m}-${d} ${h}:${n}`;
},
Date.prototype.toIsoDateStr = function() {
  var y = this.getFullYear();
  var m = (this.getMonth()+1).toString().zeroFill();
  var d = this.getDate().toString().zeroFill();
  return `${y}-${m}-${d}`;
},
Date.prototype.toFlatDateStr = function() {
  var y = this.getFullYear();
  var m = (this.getMonth()+1).toString().zeroFill();
  var d = this.getDate().toString().zeroFill();
  return `${y}${m}${d}`;
},
Date.prototype.toIsoTimeStr = function() {
  var h = this.getHours().toString().zeroFill();
  var n = this.getMinutes().toString().zeroFill();
  return `${h}:${n}`;
},
Date.prototype.getMonday = function() {
  var date = new Date(this);
  var day = date.getDay();
  if(day==0) day=7
  if( day !== 1 )
      date.setHours(-24 * (day-1)); // -2 para lunes
  return date;
}
Date.prototype.nextWeek = function() {
  var date = new Date(this);
  date.setDate(date.getDate()+7);
  return date;
}
Date.prototype.prevWeek = function() {
  var date = new Date(this);
  date.setDate(date.getDate()-7);
  return date;
}

// Funciones helpers
window.objToParams = function(obj) {
  var str = [];
  for(var p in obj)
     str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
  return str.join("&");
};

// #endregion

// #region Control de inactividad
// TODO: sistema de control de inactividad
var app_timer;

function mustReload() {
  //console.log("mustReload");
  //app_timer = setTimeout(reloadPage, 2000);
}

function reloadPage() {
  //console.log("Hello TimeOut!");
  mustReload();
}
// #endregion
const eventsHub = new Vue()
const optionsIdleVue = {
  eventEmitter: eventsHub,
  idleTime: parseInt(document.getElementById('app').dataset.auto_refresh) || 120000 // 2 min
}

Vue.use(IdleVue, optionsIdleVue)

var app = new Vue({
  el: '#app',
  data: {
    init_page: null,
    page_titles: {
      'welcome':            {label: 'Bienvenido al COIICO', back: false},
      'home':               {label: 'Seleccione el trámite que desea realizar', back: false},
      'login-dni':          {label: 'Validando DNI electrónico', back: 'welcome'},
      'login-public':       {label: 'Eventos públicos', back: 'welcome'},
      'login':              {label: 'Acceso con usuario / contraseña', back: false},
      'new-appointment':    {label: 'Cita previa', back: 'home'},
      'my-appointments':    {label: 'Cita previa', back: 'home'},
      'calendar':           {label: 'Cita previa', back: 'new-appointment'},
      'events-list':        {label: 'Eventos / Actividades', back: 'home'},
      'events-my-calendar': {label: 'Eventos / Actividades', back: 'home'},
      'inscription':        {label: 'Preinscripción', back: 'events-list'},
      'test':               {label: 'Pruebas', back: 'welcome'},
    },
    api_url: '',
    access_token: null,
    delegations: [],
    selected_delegation: null,
    user: null,
    user_profile: null,
    external_user: null,
    user_phones: [],
    loading_user_profile: false,
    page: null,
    welcome_page: null,
    title: null,
    today: new Date(),
    back_page: true,
    selected_event: null,
    debug: false,
    debug_init_page: false,
    member_external_room_id: null,
    igic: 0.07,
  },
  components: {
    AppComponent,
  },
  methods: {
    user_data_url: function() {
      return `${this.api_url}/oauth/me?access_token=${this.access_token}`;
    },
    user_profile_url: function() {
      return `${this.api_url}/oauth/my-profile?access_token=${this.access_token}`;
    },
    delegations_url: function() {
      // TODO: activar end point para PRE
      return `${this.api_url}/delegations`;
      //return 'https://intranet.coiico.es/api/delegations'
    },
    my_appointments_url: function() {
      return `${this.api_url}/oauth/my-appointments?access_token=${this.access_token}`;
    },
    delete_appointment_url: function() {
      return `${this.api_url}/oauth/delete_appointment`;
    },
    events_url: function() {
      return `${this.api_url}/events`;
    },
    external_events_url: function() {
      return `${this.api_url}/next_events_external`;
    },
    my_events_url: function() {
      return `${this.api_url}/oauth/my-tickets?access_token=${this.access_token}`;
    },
    login_dni_url: function() {
      return this.dni_url;
    },
    create_ticket_url: function() {
      return `${this.api_url}/oauth/create_ticket`;
    },
    news_url: function() {
      return `${this.api_url}/webNews`;
    },
    isLogged: function () {
      if(!this.access_token)
        return false;

      return true;
    },
    setAccessToken: function (access_token) {
      this.access_token = access_token;
      sessionStorage.access_token = access_token;
      if(!access_token) {
        this.user = null;
        this.user_profile = null;
        this.loading_user_profile = false;
        sessionStorage.removeItem('access_token');
      }
      if(!this.user) {
        this.loadUserData();
      }
    },
    loadDelegations: function() {
      //console.log('loadDelegations');
      if(this.delegations.length==0) {
        return fetch(this.delegations_url()).then(response => response.json()).then(json => {
          //console.log('ROOT json', this.user);
          this.delegations = json;
        })
      } else {
        return new Promise( resolve => resolve('Delegaciones ya cargadas'));
      }
    },
    delegationColor: function(delegation_id) {
      //console.log('delegation', delegation_id)
      for(var d in this.delegations) {
        let dlg = this.delegations[d];
        if(dlg.id == delegation_id) {
          return dlg.color;
        }
      }
      return 'red';
    },
    loadUserData: function() {
      //console.log('LOADING USER DATA', this.user_data_url());
      if(this.access_token) {
        fetch(this.user_data_url(),{
          method: 'GET',
        }).then(response => response.json()).then(json => {
          //console.log('USER DATA', json);
          this.user = json;
          this.external_user = null;
        })
      }
    },
    loadUserProfile: function() {
      //console.log('loadUserProfile')
      if(this.access_token && !this.loading_user_profile) {
        this.loading_user_profile = true;
        fetch(this.user_profile_url(),{
          method: 'GET',
        }).then(response => response.json()).then(json => {
          //console.log('USER PROFILE', json);
          this.user_profile = json;
          this.loading_user_profile = false;
          this.user_phones = [];
          ['mobile1', 'mobile2', 'phone1', 'phone2'].forEach(p => {
            if(this.user_profile[p] && this.user_profile[p]!='') this.user_phones.push(this.user_profile[p]);
          });
        }).catch(error => {
          //console.error('SE HA PRODUCIDO UN ERROR EN loasUserProfile', error);
          this.loading_user_profile = false;
          //this.setPage(this.welcome_page);
        })
      }
    },
    newAppointment: function(delegation) {
      //console.log('NEW Appointment', delegation.id);
      this.selected_delegation = delegation;
      this.setPage('calendar');
    },
    logOut: function (conf=false) {
      //console.log('LOGOUT');
      conf = conf ? confirm('¿Confirma cerrar la sesión?') : true;
      if(conf) {
        this.setAccessToken(null);
        this.setPage(this.welcome_page);
      }
    },
    setTitle: function (title) {
      this.title = title;
    },
    setPage: function (page) {
      //console.log('SETTING PAGE');
      clearTimeout(app_timer);
      mustReload();
      if(this.access_token && !this.user_profile) {
        this.loadUserProfile();
      }
      this.page = page;
      this.setTitle(this.page_titles[page]??'COIICO');
    },
  },
  mounted() {
    //console.log('MOUNTED')
    //console.log('INIT ROOT', this.$el.dataset.init_page);
    this.debug = this.$el.dataset.debug ?? false;
    this.debug_init_page = this.$el.dataset.debug_init_page ?? 'welcome';
    this.welcome_page = this.$el.dataset.welcome_page || 'welcome';
    this.dni_url = this.$el.dataset.dni_url || 'http://localhost:8000/';
    this.api_url = this.$el.dataset.api_url;
    this.member_external_room_id = this.$el.dataset.member_external_room_id;
    this.auto_refresh = this.$el.dataset.auto_refresh || 120000;
    this.igic = parseFloat(this.$el.dataset.igic ?? '0.07');
    //console.log('ROOT', this.auto_refresh);

    if(!this.debug) {
      // limpia la variable de sesión
      sessionStorage.removeItem('access_token');
    }

    if(sessionStorage.access_token) {
      this.setAccessToken(sessionStorage.access_token);
    }

    if(this.debug) {
      this.setPage(this.$el.dataset.debug_init_page || 'welcome');
    } else {
      this.setPage(this.$el.dataset.init_page || 'welcome');
    }

    mustReload();
  },
  created() {
  },

  onIdle() {
    if ( this.isLogged() ) {
      this.logOut()
    }
    window.location.reload()
  },
  onActive() {

  }
})
